import React from "react";
import "./styles/therapy.css";
import Assessment from "../../assets/assessment.jpg";
import Sunrise from "../../assets/sunrise.mp4";
import ServiceWarning from "../../components/ServiceWarning";

const ADHD = () => {
  return (
    <section className="therapy-section">
      <div className="therapy-card">
        <div className="video-banner">
          <video className="therapy-video" autoPlay muted loop playsInline>
            <source src={Sunrise} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="therapy-content">
          <h1>
            Adult assessments of attention-deficit/hyperactivity disorder (ADHD)
          </h1>
          <p>
            Attention-Deficit/Hyperactivity Disorder (ADHD) is a
            neurodevelopmental condition that impacts attention, impulse
            control, organization, and executive functioning. In adulthood, ADHD
            often presents in more subtle or internalized ways than in
            childhood, and may be misattributed to personality traits, anxiety,
            or a lack of discipline. Many adults seek an assessment after years
            of wondering why certain tasks feel harder than they should—often
            despite intelligence, motivation, or effort. Receiving an accurate
            diagnosis in adulthood can bring clarity, self- understanding, and a
            pathway toward meaningful supports and interventions.
          </p>
          <p>
            ADHD assessments are conducted within the context of a full
            psychodiagnostic assessment to ensure a nuanced and accurate
            understanding of your functioning. This is especially important
            given the high overlap between ADHD symptoms and other clinical
            conditions such as anxiety, depression, trauma-related responses,
            among many others.
          </p>
          <p>
            My assessment process is comprehensive and evidence-based. It
            includes structured clinical interviews, standardized outcome
            measures specific to ADHD and broader mental health concerns,
            collateral questionnaires (completed by friends/family), and a
            review of relevant documentation (e.g., academic report cards). The
            findings are compiled into a 10 to 12 page report, which includes
            diagnostic formulations, differential diagnoses, clinical
            conceptualizations, and individualized recommendations. A one-page
            attestation letter summarizing the diagnostic conclusion can also be
            provided when appropriate. A letter of accommodation that can be
            used at school/work is also provided when relevant to the diagnostic
            conclusions.
          </p>
          <p>
            All assessments conclude with a detailed feedback session, during
            which I walk you through the results and the clinical reasoning that
            informed the conclusions, helping you make sense of both the
            findings and the process that led us there. This collaborative
            conversation ensures that the experience is not only diagnostic, but
            also empowering and actionable.
          </p>
          <h2>Fee:</h2>
          <p>
            The total fee for ADHD assessment service is $2,860. This cost
            includes:
          </p>
          <ul className="styled-list">
            <li>Submission and review of online measures</li>

            <li>4 hours of diagnostic interviews</li>
            <li>Scoring of online-, self-reported- and collateral measures</li>
            <li>
              A comprehensive report of approximately 8-10 pages, and a letter
              of attestation containing a one-page summary of the assessment
            </li>
            <li>
              A letter of accommodation that can be used at school/work is also
              provided when relevant to the diagnostic conclusions
            </li>
            <li>
              A feedback session to review the results and treatment
              recommendations
            </li>
          </ul>
        </div>

        <div className="bottom-image-wrapper">
          <img
            src={Assessment}
            alt="Therapy session representation"
            className="therapy-image"
          />
        </div>
      </div>
      <ServiceWarning />
    </section>
  );
};

export default ADHD;
